module.exports = __webpack_public_path__ + "img/solution_2.531f5951.png";